// extracted by mini-css-extract-plugin
export default {"guestList":"OverviewCard_guestList__wmmV-"};